import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import UvodniHeroSluzby from "./sections/UvodniHeroSluzby";
import SeznamSluzeb from "./sections/SeznamSluzeb";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <UvodniHeroSluzby />
      <SeznamSluzeb />
      <CallToAction />
      <Footer />
    </div>;
}